import React, { useState } from "react";
import { fetchPermissionsUrl } from "data/features/connectionProfiles/connectionProfileApi";
import { Button } from "components/global/forms";
import PropTypes from "prop-types";

export const GrantSharepointPermissions = ({ sx, onError, children }) => {
  const [fetching, setFetching] = useState(false);
  const handleGrantPermissions = () => {
    setFetching(true);
    fetchPermissionsUrl()
      .then((response) => {
        setFetching(false);
        if (response.status === 200) {
          window.open(response.data, "_blank", "noopener");
        } else {
          onError();
        }
      })
      .catch(() => {
        setFetching(false);
        onError();
      });
  };
  return (
    <Button
      disabled={fetching}
      onClick={handleGrantPermissions}
      type="button"
      sx={sx}
    >
      {children}
    </Button>
  );
};

GrantSharepointPermissions.propTypes = {
  sx: PropTypes.object,
  children: PropTypes.node,
  onError: PropTypes.func,
};

GrantSharepointPermissions.defaultProps = {
  sx: null,
  children: null,
  onError: () => {},
};
